var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg"}),(_vm.state)?_c('router-view',{staticStyle:{"position":"relative","z-index":"9"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }